const centerChildren = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const commonStyles = {
    container: {
        ...centerChildren,
        height: '100vh',
        width: '100%',
        flexDirection: 'column',
    },

    content: {
        borderRadius: '50%',
        color: 'black',
    },

    message: {
        fontWeight: '500',
        fontFamily: '"Roboto"',
    },
};

export const loading = {
    phone: {
        ...commonStyles,
        content: {
            ...commonStyles.content,
            padding: 'clamp(1.2rem, 4vw, 3rem)', // Smaller padding for phone
        },
        message: {
            ...commonStyles.message,
            fontSize: 'clamp(1.2rem, 3vw, 3rem)', // Smaller font size for phone
            padding: '12px'
        },
    },

    tablet: {
        ...commonStyles,
        content: {
            ...commonStyles.content,
            padding: 'clamp(2rem, 4vw, 5rem)', // Medium padding for tablet
        },
        message: {
            ...commonStyles.message,
            fontSize: 'clamp(2rem, 4vw, 5rem)', // Medium font size for tablet
            padding: '12px'
        },
    },

    desktop: {
        ...commonStyles,
        content: {
            ...commonStyles.content,
            padding: 'clamp(1.8rem, 2vw, 6rem)', // Larger padding for desktop
        },
        message: {
            ...commonStyles.message,
            fontSize: 'clamp(1.8rem, 2vw, 6rem)', // Larger font size for desktop
            padding: '12px'
        },
    },

    list: {
        phone: {
            container: {
                ...centerChildren,
                height: '100vh',
                width: '100%',
                flexDirection: 'column',
            },
            table: {
                width: '100%',
                border: '.2px solid #d3d3d3',
                borderRadius: '8px',
            },
        },
        tablet: {
            container: {
                ...centerChildren,
                height: '100vh',
                width: '100%',
                flexDirection: 'column',
            },
            table: {
                width: '100%',
                border: '.2px solid #d3d3d3',
                borderRadius: '8px',
            },
        },
        desktop: {
            container: {
                ...centerChildren,
                height: '100vh',
                width: '100%',
                flexDirection: 'column',
            },
            table: {
                width: '100%',
                border: '.2px solid #d3d3d3',
                borderRadius: '8px',
            },
        },
    },
};
